import api from './api';

export function login(email, password) {
  return api.post('/auth/login', { email, password });
}

export function registerPractice(payload) {
  return api.post('/auth/register', payload);
}

export function logout(refreshToken) {
  return api.post('/auth/logout', { refreshToken });
}

export function getMe() {
  return api.get('/auth/me');
}

export function requestPasswordReset(email) {
  return api.post('/auth/forgot-password', { email });
}

export function resetPassword(token, new_password) {
  return api.post('/auth/reset-password', { token, new_password });
}
